import {
  ByEInvoice,
  ByEmail,
  ByOperator,
  DeliveryMethod,
  InvoiceSettings,
} from "../types/queries";

export const isByEInvoice = (
  settings: InvoiceSettings,
): settings is ByEInvoice => {
  return settings?.deliveryMethod === DeliveryMethod.BY_E_INVOICE;
};

export const isByEmail = (settings: InvoiceSettings): settings is ByEmail => {
  return settings?.deliveryMethod === DeliveryMethod.BY_EMAIL;
};

export const isByOperator = (
  settings: InvoiceSettings,
): settings is ByOperator => {
  return settings?.deliveryMethod === DeliveryMethod.BY_OPERATOR;
};
